import AccordionEditUser from "../../../component/AccordionEditUser/AccordionEditUser";
import PopUpComponent from "../../../component/PopUpComponent/PopUpComponent";
import FormContract from "../../../component/FormContract/FormContract";
import CloseIcon from "../../../asset/close_icon.png";
import "../../../component/AccordionEditUser/AccordionEditUser.css";
import { hasRole } from "../../../util/function";
import "./EditUser.css";
import { useEditUser } from "./useEditUser";

const EDIT_TYPES = ["Data Diri", "Data Keuangan", "Data Kontrak"];

const EditUser = () => {
  const {
    jsonRole,
    popUpImport,
    setPopUpImport,
    popUp,
    setPopUp,
    handleTambahHari,
    setFile,
    handleConvert,
    setValueSearch,
    setEditType,
    editType,
    exportGaji,
    exportDataDiri,
    peopleInfoAll,
    setPeopleInfoAll,
    dataTemp,
    peopleInfo,
    setPeopleInfo,
    isPopUpContract,
    setIsPopupContract,
    dataPickContract,
    setDataPickContract,
    dateFrom,
    setDateFrom,
    dateUntil,
    setDateUntil,
    posisi,
    setPosisi,
    umur,
    setUmur,
    handleKirimKontrak,
    isDisabled,
    setIsDisabled,
    isPopUpListContract,
    setIsPopUpListContract,
    loadingKontrakList,
    handlePickKontrak,
    selectedYear,
    setSelectedYear,
    availableYears,
    filteredKontrakList,
    isCreated,
    setIsCreated,
    dataPickHistoryContract,
    setDataPickHistoryContract,
    handleOpenNewContract,
    setIsReload,
  } = useEditUser();

  const isAdmin = hasRole(jsonRole, "hrd_admin", "super_user");
  const isNewPayroll = jsonRole.isNew === true;
  const showCheckbox = isAdmin && !isNewPayroll;
  const canSeeContract = jsonRole.tim === 1 && isAdmin;
  const visibleTypes = EDIT_TYPES.filter(
    (type) => type !== "Data Kontrak" || canSeeContract
  );

  return (
    <div className="container-edituser">
      {/* ---------- Popup riwayat kontrak ---------- */}
      {isPopUpListContract && (
        <PopUpComponent
          style={{
            marginTop: "3px",
            height: "96vh",
            width: "fit-content",
            maxWidth: "100%",
            overflowY: "auto",
            padding: "0",
            background: "var(--eu-paper)",
          }}
        >
          <div className="contract-list__header">
            <div>
              <div className="contract-list__eyebrow">Berkas kontrak</div>
              <div className="contract-list__name">
                {dataPickHistoryContract?.name || ""}
              </div>
            </div>
            <img
              className="contract-list__close"
              src={CloseIcon}
              alt="Tutup"
              onClick={() => {
                setIsPopUpListContract(false);
                setDataPickHistoryContract();
              }}
            />
          </div>

          <div className="contract-list__body">
            <div className="contract-list__filter">
              <label htmlFor="filter-tahun">Filter tahun</label>
              <select
                id="filter-tahun"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                <option value="Semua">Semua tahun</option>
                {availableYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            {loadingKontrakList ? (
              <p className="contract-list__state">Membuka berkas...</p>
            ) : filteredKontrakList.length === 0 ? (
              <div className="contract-list__empty">
                {selectedYear === "Semua"
                  ? "Belum ada riwayat kontrak untuk karyawan ini."
                  : `Tidak ada kontrak pada tahun ${selectedYear}.`}
              </div>
            ) : (
              filteredKontrakList.map((kontrak, idx) => {
                const isAktif =
                  kontrak.dateUntil &&
                  new Date(kontrak.dateUntil) >= new Date();
                return (
                  <div
                    key={kontrak.id || idx}
                    className={`contract-item ${isAktif ? "is-active" : ""}`}
                    onClick={() => handlePickKontrak(kontrak)}
                  >
                    <div className="contract-item__main">
                      <div className="contract-item__position">
                        {kontrak.posisi}
                      </div>
                      <div className="contract-item__range">
                        {kontrak.dateFrom} &nbsp;&rarr;&nbsp;{" "}
                        {kontrak.dateUntil}
                      </div>
                    </div>

                    {kontrak.isCreated === true && (
                      <span className="badge badge--ok">Terbit</span>
                    )}
                    <span
                      className={`badge ${
                        isAktif ? "badge--gold" : "badge--muted"
                      }`}
                    >
                      {isAktif ? "Aktif" : "Berakhir"}
                    </span>
                    <span className="contract-item__open">Buka &rsaquo;</span>
                  </div>
                );
              })
            )}
          </div>
        </PopUpComponent>
      )}

      {/* ---------- Popup form kontrak ---------- */}
      {isPopUpContract && (
        <PopUpComponent
          style={{
            marginTop: "5px",
            height: "96vh",
            width: "fit-content",
            maxWidth: "100%",
            overflowY: "auto",
            padding: "12px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <img
              src={CloseIcon}
              alt="Tutup"
              style={{ width: "32px", height: "32px", cursor: "pointer" }}
              onClick={() => {
                setIsPopupContract(false);
                setDataPickContract();
                setDataPickHistoryContract();
              }}
            />
          </div>
          <FormContract
            dataUser={dataPickContract}
            dateFrom={dateFrom}
            dateUntil={dateUntil}
            posisi={posisi}
            umur={umur}
            setDateFrom={setDateFrom}
            setDateUntil={setDateUntil}
            setPosisi={setPosisi}
            setUmur={setUmur}
            handleKirim={handleKirimKontrak}
            isDisabled={isDisabled}
            setIsDisabled={setIsDisabled}
            isCreated={isCreated}
          />
        </PopUpComponent>
      )}

      {/* ---------- Popup sukses import ---------- */}
      {popUpImport && (
        <div className="modal-overlay">
          <div className="modal" role="dialog" aria-modal="true">
            <div className="modal__body">
              <p className="eu-dialog-text">
                Selamat! Data kamu sudah di-update.
              </p>
            </div>
            <div className="modal__footer">
              <button
                className="btn btn--primary"
                onClick={() => setPopUpImport(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ---------- Popup tambah hari ---------- */}
      {popUp && (
        <div className="modal-overlay">
          <div className="modal" role="dialog" aria-modal="true">
            <div className="modal__body">
              <p className="eu-dialog-text">
                Apakah kamu yakin untuk menambahkan 1 hari kerja ke seluruh
                karyawan yang <b>aktif</b>?
              </p>
            </div>
            <div className="modal__footer">
              <button
                className="btn btn--outline"
                onClick={() => setPopUp(false)}
              >
                Batal
              </button>
              <button
                className="btn btn--danger"
                onClick={() => handleTambahHari()}
              >
                Tambah
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ---------- Halaman utama ---------- */}
      <div className="wrapper-card-edituser">
        <div className="eu-header">
          <h1 className="eu-title">Data karyawan</h1>
          <div className="eu-import">
            <input
              type="file"
              accept=".xls,.xlsx"
              onChange={(e) => setFile(e.target.files[0])}
            />
            <button className="btn btn--brass" onClick={handleConvert}>
              Import
            </button>
          </div>
        </div>

        <div className="eu-toolbar">
          <div className="eu-toolbar__left">
            <input
              className="search-bar-edituser"
              placeholder="Cari nama"
              type="text"
              onChange={(e) => setValueSearch(e.target.value)}
            />
            <div className="eu-tabs" role="radiogroup" aria-label="Jenis data">
              {visibleTypes.map((type) => (
                <label className="eu-tab" key={type}>
                  <input
                    type="radio"
                    name="edit-type"
                    value={type}
                    checked={editType === type}
                    onChange={() => setEditType(type)}
                  />
                  <span>{type}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="eu-toolbar__right">
            {showCheckbox && (
              <button
                className="btn btn--outline"
                onClick={() => setPopUp(true)}
              >
                Tambah hari
              </button>
            )}
            <button className="btn btn--primary" onClick={() => exportGaji()}>
              Export gaji
            </button>
            <button
              className="btn btn--primary"
              onClick={() => exportDataDiri()}
            >
              Export data diri
            </button>
          </div>
        </div>

        <div className="eu-table-wrap">
          <table className="eu-table">
            <thead>
              <tr>
                {showCheckbox && (
                  <th className="col-check">
                    <label className="eu-check-all">
                      Semua
                      <input
                        type="checkbox"
                        checked={peopleInfoAll}
                        onChange={(e) => setPeopleInfoAll(e.target.checked)}
                      />
                    </label>
                  </th>
                )}
                <th className="col-no">No.</th>
                <th>Nama</th>
                <th>Posisi</th>
                <th className="col-center">Status</th>
                {canSeeContract && <th className="col-center">Kontrak</th>}
                <th className="col-center">Jenis</th>
                <th className="col-actions"></th>
              </tr>
            </thead>
            <tbody>
              {dataTemp &&
                dataTemp.map((data, index) => (
                  <AccordionEditUser
                    key={data.id}
                    dataUser={jsonRole}
                    data={data}
                    editType={editType}
                    index={index}
                    peopleInfo={peopleInfo}
                    setPeopleInfo={setPeopleInfo}
                    setIsPopupContract={setIsPopupContract}
                    setDataPickContract={setDataPickContract}
                    setDataPickHistoryContract={setDataPickHistoryContract}
                    setIsPopUpListContract={setIsPopUpListContract}
                    setIsCreated={setIsCreated}
                    handleOpenNewContract={handleOpenNewContract}
                    setIsReload={setIsReload}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default EditUser;
